"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * ExpandedRow inside Table
 */
var TableExpandedRow =
/*#__PURE__*/
function (_React$Component) {
  _inherits(TableExpandedRow, _React$Component);

  function TableExpandedRow() {
    _classCallCheck(this, TableExpandedRow);

    return _possibleConstructorReturn(this, _getPrototypeOf(TableExpandedRow).apply(this, arguments));
  }

  _createClass(TableExpandedRow, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          columns = _this$props.columns,
          rowData = _this$props.rowData,
          rowExpand = _this$props.rowExpand,
          rowIndex = _this$props.rowIndex,
          rowKey = _this$props.rowKey,
          rowSelection = _this$props.rowSelection;
      var numColumns = columns.length;
      var cells = [];

      if (rowSelection) {
        // push empty cell so that content is not aligned with checkbox element
        cells.push(_react.default.createElement("td", {
          key: "selectionColumn"
        }));
      }

      var isNestedTable = false;

      if (rowExpand && rowExpand.render) {
        if (typeof rowExpand.isNestedTable === 'function') {
          isNestedTable = rowExpand.isNestedTable(rowData, rowIndex);
        } else {
          isNestedTable = rowExpand.isNestedTable;
        }

        cells.push(_react.default.createElement("td", {
          key: "rowExpandContent",
          className: (0, _classnames.default)(isNestedTable ? 'nested-table' : ''),
          colSpan: numColumns
        }, rowExpand.render(rowData, rowIndex))); // push empty cell for column with row expand icon

        cells.push(_react.default.createElement("td", {
          key: "rowExpandIcon"
        }));
      }

      if (cells.length) {
        var isShown = rowExpand.rows && rowExpand.rows.indexOf(rowData[rowKey]) >= 0;
        return _react.default.createElement("tr", {
          className: (0, _classnames.default)('expanded-row', isNestedTable ? 'has-nested-table' : '', !isShown ? '-hide' : '')
        }, cells);
      }

      return null;
    }
  }]);

  return TableExpandedRow;
}(_react.default.Component);

exports.default = TableExpandedRow;
TableExpandedRow.propTypes = {
  /**
   * Array of column objects
   */
  columns: _propTypes.default.arrayOf(_propTypes.default.object),

  /**
   * Object to use as the data source for the table row.
   */
  rowData: _propTypes.default.object.isRequired,

  /**
   * Object with row expand options
   */
  rowExpand: _propTypes.default.object,

  /**
   * Index of row from data source
   */
  rowIndex: _propTypes.default.number,

  /**
   * Unique key for a row.
   */
  rowKey: _propTypes.default.string,

  /**
   * Object with row selection options
   */
  rowSelection: _propTypes.default.object
};